<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.query-title-div {
  width: 90px !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">订单管理</div>
      <!-- <div class="page-title-div">电站管理</div> -->
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">手机号</div>
            <div class="query-inputs-div flex-1">
              <!-- <el-select class="full-width" v-model="queryInfo.phoneNum" filterable size="small" clearable remote reserve-keyword :remote-method="getMobileArr">
                                <el-option v-for="item in mobileArr" :key="item.mobile" :label="item.mobile" :value="item.mobile"></el-option>
                            </el-select> -->
              <el-input
                size="small"
                v-model="queryInfo.phoneNum"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">订单编号</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.orderNo"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">订单类型</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.sourceFrom"
                clearable
              >
                <el-option label="卡" value="01"></el-option>
                <el-option label="APP外部" value="02"></el-option>
                <el-option label="APP内部" value="03"></el-option>
                <el-option label="平台" value="04"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">订单状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.chargeStepCode"
                clearable
              >
                <el-option label="开始充电" value="01"></el-option>
                <el-option label="结束充电" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">订单属性</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.orderProperty"
                clearable
              >
                <el-option label="正常" value="01"></el-option>
                <el-option label="异常" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">用户评价</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.appraiseCode"
                clearable
              >
                <el-option label="未评价" value="00"></el-option>
                <el-option label="满意" value="01"></el-option>
                <el-option label="不满意" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">支付状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.payStatus"
                clearable
              >
                <el-option label="待支付" value="01"></el-option>
                <el-option label="已支付" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">电桩类型</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.pileType"
                clearable
              >
                <el-option label="私桩" value="01"></el-option>
                <el-option label="公桩" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">电站</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.stationName"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">系统时间</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                class="full-width"
                v-model="searchTime"
                :picker-options="pickerOptions"
                style="width:340px;"
                type="datetimerange"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleDateChange"
              ></el-date-picker>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">桩型号</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.pileTypeCode"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">厂商标识</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.manufactureMark"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">软件版本</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.softVersion"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">启动方式</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.sourceFrom"
                clearable
              >
                <el-option label="刷卡" value="01"></el-option>
                <el-option label="小程序" value="02"></el-option>
                <el-option label="App" value="03"></el-option>
                <el-option label="其他" value="04"></el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="list-query-child-div flex">
                        <div class="query-title-div">开始时间</div>
                        <div class="query-inputs-div flex-1">
                            <el-date-picker class="full-width" size="small" v-model="queryInfo.beginTime" type="datetime" placeholder="" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">结束时间</div>
                        <div class="query-inputs-div flex-1">
                            <el-date-picker class="full-width" size="small" v-model="queryInfo.endTime" type="datetime" placeholder="" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </div>
                    </div> -->
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电时间</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                class="full-width"
                v-model="searchChargeTime"
                :picker-options="pickerOptions"
                style="width:340px;"
                type="datetimerange"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleChargeDateChange"
              ></el-date-picker>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">充电桩IMEI码</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.pileCode"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
        </template>
        <template slot="actions">
          <div class="">
            <button
              class="common-bg-button"
              @click="getListData(pagination, false)"
            >
              搜 索
            </button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </div>
          <div class="">
            <button
              class="common-bg-button"
              @click="toExportList"
              style="width:80px;margin-top:15px"
            >
              导出
            </button>
          </div>
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {
        phoneNum: "",
        dtTo: "",
        dtFrom: "",
        pileType: "",
        sourceFrom: "",
      },
      operates: {
        width: 180,
        fixed: "right",
        list: [
          {
            id: "report",
            label: "详情",
            type: "primary",
            show: true,
            disabled: false,
            method: (index, row) => {
              // this.$store.commit('setEditId', row.id)
              // this.$router.push({
              // 	name: pageConfig.orderDeatilRouter
              // });
              this.toDetail(row);
            },
          },
        ],
      }, // 列操作按钮
      searchTime: [],
      searchChargeTime: [],
      pickerOptions: {
        
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      chargeStepCodeArr: [],
      orderPropertyArr: [],
      sourceFromArr: [],
      mobileArr: [],
    };
  },
  methods: {
    init() {
      if (this.$route.query.mobile) {
        this.queryInfo.phoneNum = this.$route.query.mobile;
      }
      if (this.$route.query.stationNo) {
        this.queryInfo.stationNo = this.$route.query.stationNo;
      }
      this.daysHandler()
      this.getListData(this.pagination, true);
    },
    getTime() {
      var date = new Date();
      var year = date.getFullYear(); //年
      var month = date.getMonth() + 1; //月
      var mon = "";
      var day = "";
      var hour = "";
      var minute = "";
      var second = "";
      if (month < 10) {
        mon = "0" + month;
      } else {
        mon = month;
      }
      var daily = date.getDate(); //日
      if (daily < 10) {
        day = "0" + daily;
      } else {
        day = daily;
      }
      // var a = date .getTime(); //获取当前时间(从1970.1.1开始的毫秒数)
      var hours = date.getHours(); //获取当前小时数(0-23)
      if (hours < 10) {
        hour = "0" + hours;
      } else {
        hour = hours;
      }
      var minutes = date.getMinutes(); //获取当前分钟数(0-59)
      if (minutes < 10) {
        minute = "0" + minutes;
      } else {
        minute = minutes;
      }
      var seconds = date.getSeconds(); //获取当前秒数(0-59)
      if (seconds < 10) {
        second = "0" + seconds;
      } else {
        second = seconds;
      }
      var time =
        year + "-" + mon + "-" + day + " " + hour + ":" + minute + ":" + second;
      console.log(time);
      return time;
    },

    daysHandler() {
      //近24小时
      let nowTime = this.getTime();
      var a = nowTime.split(" ");
      var b = a[0].split("-");
      var c = b[2] - 1;
      var m = "";
      if (c <= 0) {
        var n = a[0].split("-");
        c = n[1] - 1;
        m = n[0] + "-" + c + "-" + "30" + " " + a[1];
      } else {
        m = b[0] + "-" + b[1] + "-" + c + " " + a[1];
      }
      this.searchChargeTime = [m, nowTime];
      this.queryInfo.beginTime = this.searchChargeTime[0];
        this.queryInfo.endTime = this.searchChargeTime[1];
      //  console.log(nowTime,m);
    },

    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.get(_, _.$A.order.pileorder, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0];
        this.queryInfo.dtTo = val[1];
      } else {
        delete this.queryInfo.dtFrom;
        delete this.queryInfo.dtTo;
      }
    },
    handleChargeDateChange(val) {
      if (val) {
        this.queryInfo.beginTime = val[0];
        this.queryInfo.endTime = val[1];
      } else {
        delete this.queryInfo.beginTime;
        delete this.queryInfo.endTime;
      }
    },
    getMobileArr(query) {
      let _ = this;
      if (query.length >= 4) {
        //this.loading = true;
        var obj = {
          sort: "-mobile",
          mobile: query,
        };
        _.$H.post(_, _.$A.cust.findCustPhoneList, obj).then((res) => {
          _.mobileArr = res.data.data;
        });
      } else {
        this.mobileArr = [];
      }
    },
    // 页面新增方法
    listAddFun() {
      this.$S.listAddFun(this, pageConfig.tableEditObj);
    },
    // 页面编辑方法
    listEditFun() {
      this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
    },
    toExportList() {
      let _ = this;
      console.log(_.queryInfo.pileType);
      if (
        _.queryInfo.dtFrom == "" ||
        _.queryInfo.dtTo == "" ||
        _.queryInfo.dtFrom == undefined ||
        _.queryInfo.dtTo == undefined
      ) {
        _.$U.error("请选择系统时间");
        return;
      }
      if (
        _.queryInfo.beginTime == "" ||
        _.queryInfo.endTime == "" ||
        _.queryInfo.beginTime == undefined ||
        _.queryInfo.endTime == undefined
      ) {
        _.$U.error("请选择充电时间");
        return;
      }
      if (_.queryInfo.pileType == "" || _.queryInfo.pileType == undefined) {
        _.$U.error("请选择电桩类型");
        return;
      }
      var k1 =
        new Date(Date.parse(_.queryInfo.dtTo.replace(/-/g, "/"))) -
        new Date(Date.parse(_.queryInfo.dtFrom.replace(/-/g, "/")));
      var k2 = Math.floor(k1 / (24 * 3600 * 1000));
      if (k2 >= "31") {
        _.$U.error("系统时间范围不能超过31天");
        return;
      }
      var t1 =
        new Date(Date.parse(_.queryInfo.endTime.replace(/-/g, "/"))) -
        new Date(Date.parse(_.queryInfo.beginTime.replace(/-/g, "/")));
      var t2 = Math.floor(t1 / (24 * 3600 * 1000));
      if (t2 >= "31") {
        _.$U.error("充电时间范围不能超过31天");
        return;
      }
      // if(_.queryInfo.sourceFrom == ''){
      //     _.$U.error('请选择订单类型');
      //     return;
      // }
      // var obj = {
      //     exportStartTime: _.queryInfo.dtFrom || '',
      //     exportEndTime: _.queryInfo.dtTo || '',
      //     dtFrom: _.queryInfo.dtFrom || '',
      //     dtTo: _.queryInfo.dtTo || '',
      //     pileType: _.queryInfo.pileType,
      //     sourceFrom: _.queryInfo.sourceFrom,
      //     dealNo: _.$store.state.userInfo.dealNo,
      //     dealerNo: _.$store.state.userInfo.dealNo,
      //     // pageNum: _.queryInfo.pageNum,
      //     // pageSize: _.queryInfo.pageSize
      // }
      (_.queryInfo.dealNo = _.$store.state.userInfo.dealNo),
        (_.queryInfo.dealerNo = _.$store.state.userInfo.dealNo),
        _.$H.post(_, _.$A.order.exportOrderList, _.queryInfo).then((res) => {
          _.$U.saveExcelFile(res.data.data);
          var downUrl = "http://ocharge.shzhida.com:6775" + res.data.data.data;
          window.open(downUrl, "_blank");
        });
    },
    toDetail(val) {
      let _ = this;
      var url = _.$router.resolve({ name: "orderDetail", query: { id: val.id, orderNo: val.orderNo } });
      window.open(url.href, "_blank");
    },
    reset() {
      this.pagination.current = 1;
      delete this.queryInfo.dealName;
      delete this.queryInfo.phoneNum;
      delete this.queryInfo.orderNo;
      delete this.queryInfo.sourceFrom;
      delete this.queryInfo.chargeStepCode;
      delete this.queryInfo.orderProperty;
      delete this.queryInfo.appraiseCode;
      delete this.queryInfo.payStatus;
      delete this.queryInfo.pileType;
      delete this.queryInfo.dtFrom;
      delete this.queryInfo.dtTo;
      delete this.queryInfo.stationName;
      delete this.queryInfo.beginTime;
      delete this.queryInfo.endTime;
      delete this.queryInfo.manufactureMark;
      delete this.queryInfo.softVersion;
      //delete this.queryInfo.sourceFrom;
      delete this.queryInfo.pileTypeCode;
      delete this.queryInfo.pileCode;
      this.searchTime = [];
      this.searchChargeTime = [];
      this.getListData(this.pagination, true);
      //this.init();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
